import { LookupValueType, DayOfWeekType } from "@/generated/openapi/api"
import { OnbTableSortOptions } from "@/models/OnbTableColumnDefinition";

function asSortString(sortOptions?: OnbTableSortOptions): string|undefined {
  if (sortOptions === undefined || sortOptions.sortBy === undefined || sortOptions.sortBy.length < 1) {
    return undefined
  }
  return sortOptions.sortBy.map(sortKey => `${sortKey}:${sortOptions.sortOrder.toUpperCase()}`).join(',')
}


const lookupValueTypes = Object.values(LookupValueType);

function getLookupValueString(lvType: LookupValueType ): string {
  return lvType + ""
}



function allWeekdays(): Set<DayOfWeekType> {
  return new Set([
    DayOfWeekType.Monday,
    DayOfWeekType.Tuesday,
    DayOfWeekType.Wednesday,
    DayOfWeekType.Thursday,
    DayOfWeekType.Friday,
    DayOfWeekType.Saturday,
    DayOfWeekType.Sunday,
  ])
}

function workWeekdays(): Set<DayOfWeekType> {
  return new Set([
    DayOfWeekType.Monday,
    DayOfWeekType.Tuesday,
    DayOfWeekType.Wednesday,
    DayOfWeekType.Thursday,
    DayOfWeekType.Friday,
  ])
}

export {
  asSortString,
  lookupValueTypes,
  getLookupValueString,
  workWeekdays,
  allWeekdays
}
